<!-- <div class="heading">Order Checkout</div> -->
<!-- PAGINATION symbol to load on screen - START -->
<div class="spinner-class" *ngIf="displayLoader">
  <div class="cx-spinner">
    <cx-spinner></cx-spinner>
  </div>
</div>
<!-- PAGINATION symbol to load on screen - END -->
<div [ngClass]="{ 'hide-page': displayLoader }">
  <div class="container-fluid order-checkout" *ngIf="cart$ | async as cart">
    <form [formGroup]="orderCheckoutForm" *ngIf="orderCheckoutForm">
      <div class="row">
        <div class="col-lg-8 col-sm-8 col-md-8 padding-0 align_self">
          <div class="sub-title">
            {{ "orderCheckOut.orderSubTitle" | cxTranslate }}:
            <strong>{{ printShippingMethod() }}</strong>
            <a (click)="editCartLink()" class="ml-2 change-text">{{ "orderCheckOut.change" | cxTranslate }}</a>
          </div>

          <div class="sub-title">
            {{ "orderCheckOut.orderType" | cxTranslate }}:
            <strong>{{ fetchedCartReviewOrder?.cartOrderType?.name }}</strong>
          </div>

          <div class="sub-title mb_0">
            {{ "orderCheckOut.orderCommissionable" | cxTranslate }}
            <strong>{{
              fetchedCartReviewOrder?.isCommissionEligible ? "Yes" : "No"
            }}</strong>
          </div>
        </div>
        <div class="col-lg-4 col-sm-4 col-md-4 padding-45">
          <div class="row cart-cost">
            <div class="col-lg-6 col-sm-6 col-md-6 right-content">
              <div class="sub-title">
                {{ "orderCheckOut.subTotal" | cxTranslate }}
              </div>
              <div class="sub-title">
                {{ "orderCheckOut.couponDiscount" | cxTranslate }}
              </div>
              <div class="sub-title">
                {{ "orderCheckOut.surcharge" | cxTranslate }}
                <i class="material-icons custom-info-icon">info</i>
              </div>

              <div *ngIf="hideTrasnportion" class="sub-title">
                {{ "orderCheckOut.transportation" | cxTranslate }}
              </div>

              <div class="sub-title" *ngIf="fetchedCartReviewOrder?.totalTax">
                {{ "orderCheckOut.taxes" | cxTranslate }}
              </div>

              <div class="cart-total">
                {{ "orderCheckOut.cartTotal" | cxTranslate }} ({{
                  fetchedCartReviewOrder?.totalItems
                }}
                items):
              </div>
            </div>
            <div class="col-lg-6 col-sm-6 col-md-6 right-content text-right">
              <div class="cost">
                {{ fetchedCartReviewOrder?.vsSubTotal?.currencyIso }}
                {{ fetchedCartReviewOrder?.vsSubTotal?.formattedValue }}
              </div>
              <div class="cost">
                {{ fetchedCartReviewOrder?.orderDiscounts?.currencyIso }}
                {{ getCouponDiscout() }}
              </div>
              <div class="cost">
                {{ fetchedCartReviewOrder?.surCharge?.currencyIso }}
                {{ fetchedCartReviewOrder?.surCharge?.formattedValue }}
              </div>

              <div *ngIf="hideTrasnportion" class="cost">
                {{ fetchedCartReviewOrder?.transportationCost?.currencyIso }}
                {{ fetchedCartReviewOrder?.transportationCost?.formattedValue }}
              </div>

              <div class="cost" *ngIf="fetchedCartReviewOrder?.totalTax">
                {{ fetchedCartReviewOrder?.totalTax?.currencyIso }}
                {{ fetchedCartReviewOrder?.totalTax?.formattedValue }}
              </div>

              <div class="cart-total">
                {{ fetchedCartReviewOrder?.totalPrice?.currencyIso }}
                {{ fetchedCartReviewOrder?.totalPrice?.formattedValue }}
              </div>
            </div>
            <div class="submit-btn">
              <button
                (click)="proceedToReview()"
                class="vs-primary-btn"
                [disabled]="proceedToCheckoutBtnStatus()"
              >
                <span>{{ "orderCheckOut.proccedToBtn" | cxTranslate }}</span>
              </button>
              <!-- <span class="block-user-error" *ngIf="userSapBlocked">
                <i class="material-icons">warning</i>
                <span class="error-message">
                  {{"orderCheckOut.actionBlocked" | cxTranslate}}
                  <a href="/contactus" class="contact-us">Customer care</a>
                </span>
              </span> -->
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12 col-sm-12 col-md-12 padding-45">
          <div class="toggle-link">
            <div *ngIf="showContent" (click)="showContent = !showContent">
              <div class="toggle-icon" mat-button (click)="accordion.openAll()">
                <i class="material-icons">keyboard_arrow_down</i
                ><span>{{ "orderCheckOut.expandAll" | cxTranslate }}</span>
              </div>
            </div>
            <div *ngIf="!showContent" (click)="showContent = !showContent">
              <div
                class="toggle-icon"
                mat-button
                (click)="accordion.closeAll()"
              >
                <i class="material-icons">keyboard_arrow_up</i
                ><span>{{ "orderCheckOut.collapseAll" | cxTranslate }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row accordion-content">
        <mat-accordion class="checkout-headers-align" [multi]="true">
          <!-- #enddocregion multi -->
          <mat-expansion-panel [expanded]="true" class="padding-l">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="header">
                  {{ "orderCheckOut.soldDetails" | cxTranslate }}
                </div>
              </mat-panel-title>
              <mat-panel-description> </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="section-container">
              {{ "orderCheckOut.soldToAddress" | cxTranslate }}
              <span
                class="selected"
                *ngIf="cart?.isCommissionEligible && !cart?.quoteCartType"
              >
                <span class="sel">{{
                  "orderCheckOut.selected" | cxTranslate
                }}</span>
              </span>
            </div>
            <div class="row">
              <div class="col-md-4 col-lg-4 col-sm-4">
                <address [ngClass]="cart?.quoteCartType ? 'disabled' : ''">
                  <div>
                    {{ cart?.billToAddress?.firstName }}
                    {{ cart?.billToAddress?.lastName }}
                  </div>
                  <div>{{ cart?.billToAddress?.companyName }}</div>
                  <div>
                    {{ cart?.billToAddress?.line1
                    }}{{ cart?.billToAddress?.line1 ? "," : " " }}
                    {{ cart?.billToAddress?.line2
                    }}{{ cart?.billToAddress?.line2 ? "," : " " }}
                  </div>
                  <div>
                    {{ cart?.billToAddress?.town
                    }}{{ cart?.billToAddress?.town ? "," : " " }}
                  </div>
                  <div>
                    {{ cart?.billToAddress?.region?.name
                    }}{{ cart?.billToAddress?.region?.name ? "," : " " }}
                  </div>
                  <div>
                    {{ cart?.billToAddress?.country?.name
                    }}{{ cart?.billToAddress?.country?.name ? "," : " " }}
                    {{ cart?.billToAddress?.postalCode }}
                  </div>
                </address>

                <!-- <div
                  class="ter-btn-holder mt-3"
                  *ngIf="cart?.isCommissionEligible"
                >
                  <button
                    class="vs-tertiary-btn"
                    [disabled]="cart?.quoteCartType ? true : false"
                    (click)="isSelectAddress = !isSelectAddress"
                  >
                    SELECT ANOTHER ADDRESS
                  </button>
                </div> -->
              </div>

              <div class="col-md-8 col-lg-8 col-sm-8 fl_right">
                <vs-address
                  *ngIf="isSelectAddress"
                  (recieveSoldToAddress)="selectedAdd($event)"
                  (closeSoldAdd)="closeForm($event)"
                  [isCommissionEligible]="cart?.isCommissionEligible"
                  [componentAddress]="componentAddress"
                  [cartName]="cartName"
                ></vs-address>
              </div>
            </div>
          </mat-expansion-panel>

          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="header">
                  {{ "orderCheckOut.shippingDetails" | cxTranslate }}
                </div>
              </mat-panel-title>
              <mat-panel-description> </mat-panel-description>
            </mat-expansion-panel-header>

            <vs-shiping-details
              [isProceedToCheckout]="isProceedToCheckout"
              
            ></vs-shiping-details>
          </mat-expansion-panel>

          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="header">
                  {{ "orderCheckOut.endCstmrDetail" | cxTranslate }}
                </div>
              </mat-panel-title>
              <mat-panel-description> </mat-panel-description>
            </mat-expansion-panel-header>
            <!-- <vs-end-customer-address ></vs-end-customer-address> -->

            <vs-customer-detail
              [isProceedToCheckout]="isProceedToCheckout"
            ></vs-customer-detail>
          </mat-expansion-panel>

          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="header">
                  {{ "orderCheckOut.shipmentMethod" | cxTranslate }}
                </div>
              </mat-panel-title>
              <mat-panel-description> </mat-panel-description>
            </mat-expansion-panel-header>
            <vs-shipment-method
              (tranportaionData)="tranportaionData($event)"
              #shipmentMethodChild
              [isProceedToCheckout]="isProceedToCheckout"
            ></vs-shipment-method>
          </mat-expansion-panel>

          <!-- <div
        *ngIf="
          (endUserCountry !== getLegalQues?.salesAreaAddress?.country?.isocode)
        "
      > -->

          <div>
            <mat-expansion-panel [expanded]="true">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <div class="header">
                    <span class="star"></span>
                    {{ "orderCheckOut.questionnaire" | cxTranslate }}
                  </div>
                </mat-panel-title>
                <mat-panel-description> </mat-panel-description>
              </mat-expansion-panel-header>
              <!-- <div class="questionnaire-brief">
                {{ "orderCheckOut.questionnaireBrief" | cxTranslate }}
              </div>
              <hr /> -->
              <div >
                <button
                  (click)="autoFill(complianceData?.vsExportComplianceQuestions)"
                  class="vs-tertiary-btn auto-fill-btn">
                  <span>{{ "orderCheckOut.autoFillBtn" | cxTranslate }}</span>
                </button>
              </div>
              <br>
              <div
                *ngFor="
                  let data of complianceData?.vsExportComplianceQuestions;
                  let i = index
                "
                class="section-login"
              >
                <div *ngIf="complianceData?.vsExportComplianceQuestions">
                  <!--Questions-->
                  <span class="question-text">{{ i + 1 }} . </span>
                  <span class="question-text" [innerHTML]="data.question">
                    <!-- {{ data.question }} -->
                  </span>
                  <div class="vs-radio-button row question">
                    <input
                      id="{{ data?.questionId }}"
                      type="radio"
                      [value]="true"
                      [checked]="
                        cartExportCompResponse[data?.questionId] == true ||
                        cartExportCompResponse[data?.questionId] == 'true'
                          ? true
                          : false
                      "
                      (change)="
                        updateQuestionaire(
                          $event.target.value,
                          data?.questionId
                        )
                      "
                      name="{{ data?.questionId }}"
                    />
                    <label class="radio-text" for="{{ data?.questionId }}">
                      {{ "orderCheckOut.yesLbl" | cxTranslate }}
                    </label>

                    <input
                      id="no+{{ data?.questionId }}"
                      type="radio"
                      [value]="false"
                      [checked]="
                        cartExportCompResponse[data?.questionId] == false
                          ? true
                          : false
                      "
                      (change)="
                        updateQuestionaire(
                          $event.target.value,
                          data?.questionId
                        )
                      "
                      name="{{ data?.questionId }}"
                    />
                    <label for="no+{{ data?.questionId }}">
                      {{ "orderCheckOut.noLbl" | cxTranslate }}
                    </label>
                  </div>
                  <div
                    *ngIf="
                      isProceedToCheckout &&
                      (cartExportCompResponse[data?.questionId] === undefined ||
                        cartExportCompResponse[data?.questionId] === null ||
                        cartExportCompResponse[data?.questionId] === '')
                    "
                  >
                    <label class="error-custom" #exportComplianceError>
                      {{ "orderCheckOut.exportComplianceQues" | cxTranslate }}
                    </label>
                  </div>
                  <div *ngIf="data?.errorCompliancecMsg">
                    <div class="error-ordercheckout" #fptError>
                      <p class="order-paragraph">
                        <i class="material-icons custom-info-icon">report</i>
                        <span class="header-msg">{{ "orderCheckOut.errorWord" | cxTranslate }}</span>
                         {{ "orderCheckOut.errorMsg" | cxTranslate }}
                      </p>
                    </div>
                  </div>
                  <div *ngIf="data?.hasRestrictedUseWarning">
                    <div class="warning-ordercheckout" #fptWarning>
                      <p class="order-paragraph">
                        <i class="material-icons custom-info-icon">warning</i>
                        <span class="header-msg">{{ "orderCheckOut.warning" | cxTranslate }}</span>
                        {{ "orderCheckOut.hasRestrictedUseWarning" | cxTranslate }}
                      </p>
                    </div>
                  </div>
                  <div *ngIf="data?.requiresExportLicenseWarning">
                    <div class="warning-ordercheckout" #fptWarning>
                      <p class="order-paragraph">
                        <i class="material-icons custom-info-icon">warning</i>
                        <span class="header-msg">{{ "orderCheckOut.warning" | cxTranslate }}</span>
                        {{ "orderCheckOut.exportLicenseWarning" | cxTranslate }}
                      </p>
                    </div>
                  </div>

                  <div
                    *ngIf="
                      data?.restrictedPartListFlag"
                  >
                    <div class="warning-ordercheckout" #fptWarning>
                      <p class="order-paragraph">
                        <i class="material-icons custom-info-icon">warning</i>
                        <span class="header-msg">{{ "orderCheckOut.warning" | cxTranslate }}</span>
                        {{ "orderCheckOut.restrictedPartListFlag" | cxTranslate }}
                      </p>
                    </div>
                  </div>
                  <div
                    *ngIf="
                      data?.governmentPartiesFlag"
                  >
                    <div class="warning-ordercheckout" #fptWarning>
                      <p class="order-paragraph">
                        <i class="material-icons custom-info-icon">warning</i>
                        <span class="header-msg">{{ "orderCheckOut.warning" | cxTranslate }}</span>{{ "orderCheckOut.governmentPartiesFlag" | cxTranslate }}
                      </p>
                    </div>
                  </div>
                  <div
                    *ngIf="
                      data?.warningMsgFlags ||
                      ((cartExportCompResponse[data?.questionId] == true ||
                        cartExportCompResponse[data?.questionId] == 'true') &&
                        data?.questionId == 'warningFlags')
                    "
                  >
                    <div class="warning-textarea-text">
                      <span class="error">*</span>
                      {{ "orderCheckOut.warningMsgFlags" | cxTranslate }}
                    </div>
                    <textarea
                      [(ngModel)]="warningFlagText"
                      maxlength="250"
                      class="warning-textarea"
                      rows="4"
                      [ngModelOptions]="{ standalone: true }"
                    ></textarea>
                    <!-- <label class="required"
                      >Remaining
                      {{ 250 - warningFlagText?.length }} characters</label
                    > -->
                  </div>
                  <div *ngIf="data?.governmentPartiesFlag">
                    <div class="warning-ordercheckout" #fptWarning>
                      <p class="order-paragraph">
                        <i class="material-icons custom-info-icon">warning</i>
                        <span class="header-msg">{{ "orderCheckOut.warning" | cxTranslate }}</span>
                        {{ "orderCheckOut.governmentPartiesFlagWarning" | cxTranslate }}
                      </p>
                    </div>
                  </div>
                  <!--Questions-->
                </div>
              </div>
            </mat-expansion-panel>
          </div>
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="header">
                  {{ "orderCheckOut.notiAndAttachement" | cxTranslate }}
                </div>
              </mat-panel-title>
              <mat-panel-description> </mat-panel-description>
            </mat-expansion-panel-header>
            <vs-notification-attachment
              #notificationAttachmentChild
              (updateFileData)="getNotifyFiles($event)"
              [isProceedToCheckout]="isProceedToCheckout"
            ></vs-notification-attachment>
          </mat-expansion-panel>

          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="header">
                  {{ "orderCheckOut.billingDetails" | cxTranslate }}
                </div>
              </mat-panel-title>
              <mat-panel-description> </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="billing">
              <div class="row">
                <div class="col-lg-7 col-md-7 col-sm-7">
                  <!-- <div class="bill-pay">
                  {{ "orderCheckOut.paymentTerm" | cxTranslate }}
                  <div class="">
                    <strong>
                      {{
                        fetchedCartReviewOrder?.notificationDetails
                          ?.paymentTerms
                      }}</strong
                    >
                  </div>
                </div> -->
                  <div class="vs-text-field mt-1">
                    <label class="bill-pay">
                      <span class="star"></span>
                      {{ "orderCheckOut.purchaseOrderNo" | cxTranslate }}</label
                    >
                    <input
                      class="width-45 wdt280 poNumberInput"
                      type="text"
                      formControlName="purchaseOrderNumber"
                      placeholder='{{ "orderCheckOut.purchaseOrderNumber" | cxTranslate }}'
                      [ngClass]="
                        (isProceedToCheckout &&
                          formControls.purchaseOrderNumber.errors?.required) ||
                        (isProceedToCheckout &&
                          !formControls.purchaseOrderNumber.errors?.required &&
                          formControls.purchaseOrderNumber.errors
                            ?.ibsPoErrorValue)||(isProceedToCheckout &&
                            formControls.purchaseOrderNumber.errors?.pattern)
                          ? 'error'
                          : ''
                      "
                      maxlength="35"
                      (change)="onPurchaseOrderReqChange($event)"
                    />

                    <label
                      #purchaseOrderNumberError
                      class="error"
                      *ngIf="
                        (isProceedToCheckout &&
                          formControls.purchaseOrderNumber.errors?.required) ||
                        (isProceedToCheckout &&
                          !formControls.purchaseOrderNumber.errors?.required &&
                          formControls.purchaseOrderNumber.errors
                            ?.ibsPoErrorValue)||(isProceedToCheckout &&
                            formControls.purchaseOrderNumber.errors?.pattern)
                      "
                    >
                      <span
                        *ngIf="
                          isProceedToCheckout &&
                          formControls.purchaseOrderNumber.errors?.required
                        "
                        >{{ "orderCheckOut.orderNoError" | cxTranslate }}</span
                      >
                      <span
                        *ngIf="
                          isProceedToCheckout &&
                          formControls.purchaseOrderNumber.errors?.pattern
                        "
                        >{{ "orderCheckOut.orderNoInvalid" | cxTranslate }}</span
                      >
                      <span
                        *ngIf="
                          isProceedToCheckout &&
                          !formControls.purchaseOrderNumber.errors?.required &&
                          formControls.purchaseOrderNumber.errors
                            ?.ibsPoErrorValue
                        "
                        >{{
                          "orderCheckOut.ibsPrefixError" | cxTranslate
                        }}</span
                      >
                    </label>
                    <!-- <label #purchaseOrderNumberError
                    class="error"
                    *ngIf="
                      (isProceedToCheckout &&
                        formControls.purchaseOrderNumber.errors?.ibsPoErrorValue)
                    "
                  >
                    Add IBS/PO Suffix
                  </label> -->
                  </div>

                  <span class="upload-text">{{
                    "orderCheckOut.uploadPurchaseOrder" | cxTranslate
                  }}</span>
                  <div class="file-upload">
                    <div>
                      <label
                        class="custom-upload"
                        [ngClass]="{ 'disabled-btn': disbledBtn }"
                        for="demofile"
                      >
                        <input
                          class="hidden upload-input"
                          multiple
                          id="demofile"
                          type="file"
                          (change)="upload($event)"
                        />
                        <i class="material-icons custom-upload-icon">backup</i>
                        <span>
                          {{ "orderCheckOut.uploadFile" | cxTranslate }}
                        </span>
                      </label>
                    </div>
                    <div class="upload">
                      {{ "orderCheckOut.fileFormatena" | cxTranslate }}
                    </div>
                  </div>

                  <div class="row doc-width" id="documentClose">
                    <div id="docInner" #docInner class="section-document">
                      <div
                        id="fileInfo"
                        #fileInfo
                        class="fileInfo-section"
                      ></div>

                      <div *ngIf="cart?.poAttachments">
                        <div
                          id="fileInfo"
                          class="fileInfo-section"
                          *ngFor="let file of cart?.poAttachments"
                        >
                          <i class="material-icons material-icons-custom"
                            >receipt</i
                          >
                          <span id="para11" class="pl-0">{{
                            file?.realFileName
                          }}</span>
                          <span id="para22">{{
                            getFileSize(file.attachmentSizes)
                          }}</span>

                          <!--<span id="para22">{{ (file?.attachmentSizes/ (1024*1024)).toFixed(2) + 'mb' }}</span>-->
                          <span
                            id="close"
                            class="closeId-img"
                            (click)="closeFile($event, file.mediaCode)"
                          >
                            <i class="material-icons">close</i>
                          </span>
                        </div>
                      </div>

                      <p
                        class="section-document-document-details error-msg"
                        id="fileMaxLenghtExceed"
                        #fileMaxLenghtExceed
                      ></p>
                      <p
                        id="fileSizeExceed"
                        #fileSizeExceed
                        class="section-document-document-details error-msg"
                      ></p>

                      <p
                        id="fileType"
                        #fileType
                        class="section-document-document-details error-msg"
                      ></p>

                      <p
                        id="fileDuplicate"
                        #fileDuplicate
                        class="section-document-document-details error-msg"
                      ></p>
                      <p
                        id="filenameLengthNotify"
                        #filenameLengthNotify
                        class="section-document-document-details error-msg"
                      ></p>
                      <p
                        id="filenameSpecialcharNotify"
                        #filenameSpecialcharNotify
                        class="section-document-document-details error-msg"
                      ></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </mat-expansion-panel>

          <div class="checkout-warning mt-3">
            <i class="material-icons mr-2">warning</i>
            <span class="warning-text"
              ><b class="mr-2">{{ "orderCheckOut.warning" | cxTranslate }}:</b>{{ "orderCheckOut.additionalCommentsDocs" | cxTranslate }}
             </span
            >
          </div>

          <div class="row">
            <div class="col-lg-8 col-sm-8 col-md-8 padding-45"></div>

            <div class="col-lg-4 col-sm-4 col-md-4">
              <div class="row cart-cost pl40">
                <div class="col-lg-6 col-sm-6 col-md-6 right-content padding_0">
                  <div class="sub-title">
                    {{ "orderCheckOut.subTotal" | cxTranslate }}
                  </div>
                  <div class="sub-title">
                    {{ "orderCheckOut.couponDiscount" | cxTranslate }}
                  </div>
                  <div class="sub-title">
                    {{ "orderCheckOut.surcharge" | cxTranslate }}
                    <i class="material-icons custom-info-icon">info</i>
                  </div>
                  <!-- <i id="tool" class="material-icons custom-info-icon">info</i> -->
                  <div *ngIf="hideTrasnportion" class="sub-title">
                    {{ "orderCheckOut.transportation" | cxTranslate }}
                  </div>

                  <div
                    class="sub-title"
                    *ngIf="fetchedCartReviewOrder?.totalTax"
                  >
                    {{ "orderCheckOut.taxes" | cxTranslate }}
                  </div>

                  <div class="cart-total">
                    {{ "orderCheckOut.cartTotal" | cxTranslate }} ({{
                      fetchedCartReviewOrder?.totalItems
                    }}
                    {{ "orderCheckOut.items" | cxTranslate }}): 
                  </div>
                </div>
                <div
                  class="col-lg-6 col-sm-6 col-md-6 right-content text-right"
                >
                  <div class="cost">
                    {{ fetchedCartReviewOrder?.vsSubTotal?.currencyIso }}
                    {{ fetchedCartReviewOrder?.vsSubTotal?.formattedValue }}
                  </div>
                  <div class="cost">
                    {{ fetchedCartReviewOrder?.orderDiscounts?.currencyIso }}
                    {{ getCouponDiscout() }}
                  </div>

                  <div class="cost">
                    {{ fetchedCartReviewOrder?.surCharge?.currencyIso }}
                    {{ fetchedCartReviewOrder?.surCharge?.formattedValue }}
                  </div>

                  <div *ngIf="hideTrasnportion" class="cost">
                    {{
                      fetchedCartReviewOrder?.transportationCost?.currencyIso
                    }}
                    {{
                      fetchedCartReviewOrder?.transportationCost?.formattedValue
                    }}
                  </div>

                  <div class="cost" *ngIf="fetchedCartReviewOrder?.totalTax">
                    {{ fetchedCartReviewOrder?.totalTax?.currencyIso }}
                    {{ fetchedCartReviewOrder?.totalTax?.formattedValue }}
                  </div>

                  <div class="cart-total">
                    {{ fetchedCartReviewOrder?.totalPrice?.currencyIso }}
                    {{ fetchedCartReviewOrder?.totalPrice?.formattedValue }}
                  </div>
                </div>
                <div class="submit-btn">
                  <button
                    (click)="proceedToReview()"
                    class="vs-primary-btn"
                    [disabled]="proceedToCheckoutBtnStatus()"
                  >
                    <span>{{
                      "orderCheckOut.proccedToBtn" | cxTranslate
                    }}</span>
                  </button>
                  <!-- <span class="block-user-error" *ngIf="userSapBlocked">
                    <i class="material-icons">warning</i>
                    <span class="error-message">
                      {{"orderCheckOut.actionBlocked" | cxTranslate}}
                      <a href="/contactus" class="contact-us">Customer care</a>
                    </span>
                  </span> -->
                </div>
              </div>
            </div>
          </div>
          <br /><br />
        </mat-accordion>
      </div>
    </form>
  </div>
</div>
